import customHeaders, { getSpace } from '../../../common/headers';
import link_icon from './img/link_icon.svg'
import drop_icon from './img/drop_icon.svg'
import drop_active_icon from './img/drop-active_icon.svg'
import { RavshanArticlesHttps } from '../../../fetchUrls';
import { handleApiResponseOrThrow } from '../../../common/utils';
import { RavshanHttps, RavshanHttp } from '../../../fetchUrls';
import { useEffect, useState, useRef, useCallback } from 'react';
import { InputSearch, ArticleView, ShortTileArticleBox, usePagination, NoArticles } from "@lk-gtcom/ecomlab-components";
import useGeneralStore from '../../../store/general';
import { getParamsQuery } from '../../../common/utils';
import { ModalMiltilevelSidebarSettings } from '../ModalMiltilevelSidebarSettings/ModalMiltilevelSidebarSettings';
import Breadcrumb from '../../../pages/ArticleComponents/ArticleTypesComponent/Breadcrumb/Breadcrumb';
import { MoonLoader } from 'react-spinners';
import "./ModalKnowledgeBase.scss"
import ArticleViewV2 from '../../../pages/ArticleComponents/ArticleViewV2/ArticleViewV2';

const ModalKnowledgeBase = ({ setIsModal, sidebarItems, isModal }) => {
    const selectedSpace = useGeneralStore(state => state.selectedSpace)
    const headers = { ...customHeaders, ...getSpace(selectedSpace) }
    const html = document.querySelector('html')
    const [isOpen, setIsOpen] = useState(new Set())
    const [breadcrumbs, setBreadcrumbs] = useState([])
    const [isActiveSection, setIsActiveSection] = useState(null)

    const [activeMenuItem, setActiveMenuItem] = useState(null)
    const [articles, setArticles] = useState([])
    const [search, setSearch] = useState('')
    const [loadingSidebar, setLoadingSidebar] = useState(false)

    const [contentData, setContentData] = useState([])
    const [apiData, setApiData] = useState(null)
    const setContentDataCallback = useCallback(e => setContentData(e), [])
    const [contentLinks, setContentLinks] = useState([])

    const [levelId, setLevelId] = useState(null)
    const [articleId, setArticleId] = useState(null)

    const [selectedLevelValue, setSelectedLevelValue] = useState(0);
    const [selectedItemId, setSelectedItemId] = useState();

    // Для открытия статей по квери
    useEffect(() => {
        let level_id = getParamsQuery('level-id')
        let article_id = getParamsQuery('article-id')
        if (level_id) setLevelId(level_id)
        if (article_id) setArticleId(article_id)
    }, []);

    // Крошки

    const fetchGetBreadcrumbs = (level_id, article_id) => {

        const level_id_params = level_id ? `?level_id=${level_id}` : ''
        const article_id_params = article_id ? `&article_id=${article_id}` : ''
        let url = ` https://portals.ecomru.ru/api/v2/article/get_bread_crumbs${level_id_params}${article_id_params}`

        fetch(url, { method: 'GET', headers })
            .then(res => {
                if (res.ok) {
                    return res.json()
                } else {
                    throw new Error('bad response')
                }
            })
            .then(json => {
                setBreadcrumbs(json)
            })
            .catch(err => console.error(err))
    }

    const openContainer = (label) => {
        const newState = new Set(isOpen)
        if (newState.has(label)) {
            newState.delete(label)
        } else {
            newState.add(label)
        }
        setIsOpen(newState)
    }

    const paginatorRef = useRef()
    const paginatorCallback2 = useRef()

    const [
        page,
        limit,
        total,
        setTotal,
        Paginator,
        resetPaginator,
        paginatorTransition
    ] = usePagination(paginatorCallback2.current, [], paginatorRef.current?.params)

    const fetchArticlesByLevel = (value, params) => {
        setApiData(null)
        setIsActiveSection(null)
        const abortController = new AbortController()

        const url = `${RavshanArticlesHttps}/api/v2/article/get_articles_by_parent`

        let filters = null, sorting = null
        if (params?.length) {
            [sorting, filters] = params
        }

        const orderParam = ''
        const orderParamDirection = ''

        const body = JSON.stringify({
            level_id: selectedLevelValue,
            search: search,
            language: 'ru',
            active: true,
            // readed: true,
            page: page,
            limit: limit ?? 10,
            view: "table",
            order_param_direction: 'desc',
            order_param: 'date',
            filters: filters,
            status: "active"
        })

        // if (orderParam) Object.assign(getHeaders, { "order-param": btoa(encodeURI(orderParam)) })
        // if (orderParamDirection) Object.assign(getHeaders, { "order-param-direction": orderParamDirection })
        // if (filters && filters.length) Object.assign(getHeaders, { "filters": btoa(encodeURI(JSON.stringify({ filters }))) })

        fetch(url, { method: 'POST', body, headers, signal: abortController.signal })
            .then(res => res.json())
            .then(json => {
                if (selectedLevelValue) {
                    setArticles(json?.data)
                }
                setTotal(json.total)
            })
            .catch(err => console.error(err))
        return abortController
    }

    const fetchArticleSearch = (id) => {
        let url
        if (!window.location.hostname.match('localhost')) {
            url = `${RavshanHttps}/search`
        } else {
            url = `${RavshanHttp}/search`
        }

        const currentHeaders = {
            ...headers,
            // 'language': 'ru',
            // 'level-id': activeMenuItem,
            // "portal_id": 3,
            // 'page': page,
            // 'limit': limit
        }

        const body = JSON.stringify({
            query: search,
            'language': 'ru',
            'level_id': activeMenuItem,
            "portal_id": 3,
            'page': page,
            'limit': limit
        })

        fetch(url, { body, method: 'POST', headers: currentHeaders })
            .then(async res => {
                if (res.ok) {
                    return res.json()
                } else {
                    const err = res.json()
                    throw new Error(JSON.stringify(err))
                }
            })
            .then(json => {
                const { data, labels, total, sort, column_size } = json
                setTotal(json.total)
                setArticles(json?.data)
                setArticles(data)
            })
            .catch(err => console.error(err))
    }

    const fetchGeArticleByPortal = (id) => {
        // setLoading(true)
        const url = `${RavshanArticlesHttps}/api/v2/article/get_article/${id}`
        // const getHeaders = {
        //     ...headers,
        //     'article-id': id ? id : articleId,
        //     'Accept': 'application/json',
        //     'active': true,
        //     'redactor': true
        // }
        fetch(url, { headers })
            .then(async res => {
                if (res.ok) {
                    return res.json()
                } else {
                    const err = await res.json()
                    throw new Error(JSON.stringify(err))
                }
            })
            .then(json => {
                // if (Object.keys(json).length === 0) {
                //     navigate(`/wiki/${pathBread}/${BASE_ROUTE}`)
                // }
                setApiData(json)
                //  setCurrentArticle({ title: json.name, breadcrumbs: json.breadCrumbs })
                // setBreadcrumbs(json?.breadCrumbs)
            })
            .catch(error => console.error(error))
        //  .finally(() => setLoading(false))
    }

    useEffect(() => {
        if (isModal && apiData) {
            html.style = 'overflow: hidden'
        }
    })

    useEffect(() => {
        setApiData(null)
        if (search?.length > 0) {
            resetPaginator()
        }
    }, [search]);

    useEffect(() => {
        fetchArticlesByLevel()
    }, [selectedLevelValue, page, limit, search]);

    useEffect(() => {
        if (apiData?.level_id && apiData?.id) {
            fetchGetBreadcrumbs(apiData?.level_id, apiData?.id)
            setSelectedItemId(apiData?.level_id)
        }
    }, [apiData]);

    useEffect(() => {
        if (!apiData?.level_id) {
            fetchGetBreadcrumbs(selectedLevelValue)
        }
    }, [selectedLevelValue, apiData]);


    return (
        <div className='blackout' onClick={(e) => {
            let el = e.target
            if (el.classList.contains('blackout')) {
                setIsModal(false)
                html.style = 'overflow: unset'
            }
        }}>
            <div className='modal-knowledge-base'>
                <div className='sidebar-wiki__side-panel'>
                    <h1 className='sidebar-wiki__title'>База знаний <span>Ecomru</span>
                        <a target="_blank"
                            style={{ marginLeft: 'auto' }}
                            href='https://wiki.ecomru.ru/'><img src={link_icon} /></a>
                    </h1>
                    <div className='sidebar-wiki__container'>
                        {
                            loadingSidebar ?
                                <div className='sidebar-wiki__load-box'>
                                    <MoonLoader />
                                </div>
                                :
                                <ModalMiltilevelSidebarSettings
                                    stopRedirect
                                    tokenWiki={'gAAAAABox-qR_pBYIjOxoF3paqyKeTIECO8mpF704lH6HcPLyKOtzb0tbSJiW6_K8GvLeAWby_zkxQej-NGCVANcgKFnxDkHWw=='}
                                    readonly={true}
                                    breadcrumbs={breadcrumbs}
                                    fetchGetBreadcrumbs={() => { }}
                                    setTitle={(e) => (e)}
                                    setPathsWebName={(e) => (e)}
                                    onPortalClick={(id) => {
                                        setSelectedLevelValue(id);
                                    }}
                                    onLevelClick={(id) => {
                                        setSelectedLevelValue(id);
                                    }}
                                    setPaths={(e) => (e)}
                                    selectedItemId={selectedItemId}
                                    setSelectedItemId={setSelectedItemId}
                                    isSearching={false}
                                />
                        }
                    </div>
                </div>



                <div className='modal-knowledge-base__content'>
                    <InputSearch
                        onChange={(e) => setSearch(e)}
                    />

                    <Breadcrumb
                        mainPath='/landing/charts'
                        breadcrumbs={breadcrumbs}
                        setSelectedItemId={setSelectedItemId}
                        setTitle={(e) => (e)}
                        onPortalClick={(id) => {
                            setSelectedLevelValue(id)
                        }}
                        stopRedirect
                    />

                    {search?.length > 0 && <p className='breadcrumbs-list__item'>Результаты поиска</p>}

                    {apiData?.name ?
                        (apiData?.name ? <div className='modal-knowledge-base__article-box'>
                            <ArticleViewV2
                                modalStyle
                                readonly
                                articleTitle={apiData?.name}
                                apiData={apiData}
                                contentData={contentData}
                                setContentData={setContentDataCallback}
                                setListOfContent={setContentLinks}
                                hideInfoPanel
                                hideRecommendation
                            />
                        </div>
                            : 'В этой статье нет информации'
                        )
                        :
                        articles?.length ?
                            <div className='article-main-content'>
                                <div className='article-main-content__content'>
                                    {articles.map((data, ind) => {
                                        const id = data[0]
                                        const annotation = data[4]
                                        const name = data[3]

                                        return <div
                                            style={{ width: '100%', height: 'fit-content' }}
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                fetchGeArticleByPortal(id)

                                            }}>
                                            <ShortTileArticleBox
                                                wikiStyle
                                                id={id}
                                                name={name}
                                                annotation={annotation}
                                                statusArray={["https://dl.ecomru.ru/svg-storage/icon-waiting.svg", "Update"]}
                                                onLinkClick={(e) => (e)}
                                                showStatus
                                                stopRedirect
                                            />
                                        </div>
                                    })}
                                </div>
                                {Paginator}

                            </div>
                            :
                            <NoArticles />

                    }
                </div>
            </div>
        </div >
    )
}
export { ModalKnowledgeBase }